module.exports = __webpack_public_path__ + "static/media/homepage_metaverse-mobile.9431f168.mp4";